import _ from "underscore";

import Backbone from "pages/common/lib/backbone-helpers";

const OrganizationModel = Backbone.Model.extend({
    defaults: {
        isMfaEnabled: false
    },

    idAttribute: `organizationId`,

    parse: function (attrs) {
        if (attrs.inlineTypeConfig && _.isString(attrs.inlineTypeConfig)) {
            attrs.inlineTypeConfig = JSON.parse(attrs.inlineTypeConfig);
        }
        return attrs;
    },

    isMfaEnabled: function () {
        return this.get(`isMfaEnabled`);
    },

    isMaxNumberOfUsersReached(numOfUsers) {
        if (this.has(`maxNumberOfUsers`)) {
            return numOfUsers >= this.get(`maxNumberOfUsers`);
        }
        return false;
    }
});

export default OrganizationModel;
